// Step -2 Add Policy Start
export const ADD_POLICY_START = "ADD_POLICY_START"
export const ADD_POLICY_SUCCESS = "ADD_POLICY_SUCCESS"
export const ADD_POLICY_FAILURE = "ADD_POLICY_FAILURE"
export const ADD_POLICY_RESET = "ADD_POLICY_RESET"

// setp -1 Add Policy-Type
export const ADD_POLICY_TYPE_START = "ADD_POLICY_TYPE_START"
export const ADD_POLICY_TYPE_SUCCESS = "ADD_POLICY_TYPE_SUCCESS"
export const ADD_POLICY_TYPE_FAILURE = "ADD_POLICY_TYPE_FAILURE"
export const ADD_POLICY_TYPE_RESET = "ADD_POLICY_TYPE_RESET"

// Step -3 View Policy
export const VIEW_POLICY_TYPE_START = "VIEW_POLICY_TYPE_START"
export const VIEW_POLICY_TYPE_SUCCESS = "VIEW_POLICY_TYPE_SUCCESS"
export const VIEW_POLICY_TYPE_FAILURE = "VIEW_POLICY_TYPE_FAILURE"

// step 4
export const GET_POLICY_CUSTOMER_START = "GET_POLICY_CUSTOMER_START"
export const GET_POLICY_CUSTOMER_SUCCESS = "GET_POLICY_CUSTOMER_SUCCESS"
export const GET_POLICY_CUSTOMER_FAILURE = "GET_POLICY_CUSTOMER_FAILURE"
export const GET_POLICY_CUSTOMER_RESET = "GET_POLICY_CUSTOMER_RESET"

export const UPDATE_POLICY_START = "UPDATE_POLICY_START"
export const UPDATE_POLICY_SUCCESS = "UPDATE_POLICY_SUCCESS"
export const UPDATE_POLICY_FAILURE = "UPDATE_POLICY_FAILURE"
export const UPDATE_POLICY_RESET = "UPDATE_POLICY_RESET"

// 6 Policy By customer id

export const GET_POLICY_CUSTOMER_ID_START = "GET_POLICY_CUSTOMER_ID_START"
export const GET_POLICY_CUSTOMER_ID_SUCCESS = "POLICY_CUSTOMER_ID_SUCCESS"
export const GET_POLICY_CUSTOMER_ID_FAILURE = "GET_POLICY_CUSTOMER_ID_FAILURE"
export const GET_POLICY_CUSTOMER_ID_RESET = "GET_POLICY_CUSTOMER_ID_RESET"

// 7. Get Company Name
export const GET_Company_START = "GET_Company_START"
export const GET_Company_SUCCESS = "GET_Company_SUCCESS"
export const GET_Company_FAILURE = "GET_Company_FAILURE"
export const GET_Company_RESET = "GET_Company_RESET"

// 8 . Get Policy Name
export const GET_POLICY_START = "GET_POLICY_START"
export const GET_POLICY_SUCCESS = "GET_POLICY_SUCCESS"
export const GET_POLICY_FAILURE = "GET_POLICY_FAILURE"
export const GET_POLICY_RESET = "GET_POLICY_RESET"

// 9. Get Sub-Policy Name
export const GET_SUB_POLICY_START = "GET_SUB_POLICY_START"
export const GET_SUB_POLICY_SUCCESS = "GET_SUB_POLICY_SUCCESS"
export const GET_SUB_POLICY_FAILURE = "GET_SUB_POLICY_FAILURE"
export const GET_SUB_POLICY_RESET = "GET_SUB_POLICY_RESET"

// 10 . Get Sub-LOB Name
export const GET_SUB_LOB_START = "GET_SUB_LOB_START"
export const GET_SUB_LOB_SUCCESS = "GET_SUB_LOB_SUCCESS"
export const GET_SUB_LOB_FAILURE = "GET_SUB_LOB_FAILURE"
export const GET_SUB_LOB_RESET = "GET_SUB_LOB_RESET"

// 11 .Policy Linking
export const POLICY_LINKING_START = "POLICY_LINKING_START"
export const POLICY_LINKING_SUCCESS = "POLICY_LINKING_SUCCESS"
export const POLICY_LINKING_FAILURE = "POLICY_LINKING_FAILURE"
export const POLICY_LINKING_RESET = "POLICY_LINKING_RESET"

//12 . /all-policies-link

export const GET_RRODUCT_START = "GET_RRODUCT_START"
export const GET_RRODUCT_SUCCESS = "GET_RRODUCT_SUCCESS"
export const GET_RRODUCT_FAILURE = "GET_RRODUCT_FAILURE"
export const GET_RRODUCT_RESET = "GET_RRODUCT_RESET"

// 13. GST API
export const GET_GST_START = "GET_GST_START"
export const GET_GST_SUCCESS = "GET_GST_SUCCESS"
export const GET_GST_FAILURE = "GET_GST_FAILURE"
export const GET_GST_RESET = "GET_GST_RESET"

// 14. LOB wise wise fields

// setp -1 Add Policy-Type
export const GetAdditionalLOB_START = "GetAdditionalLOB_START"
export const GetAdditionalLOB_SUCCESS = "GetAdditionalLOB_SUCCESS"
export const GetAdditionalLOB_FAILURE = "GetAdditionalLOB_FAILURE"
export const GetAdditionalLOB_RESET = "GetAdditionalLOB_RESET"

export const GET_ENUM_VALUE = "GET_ENUM_VALUE"
export const RESET_ENUM_VALUE = "RESET_ENUM_VALUE"

// Hide some fields

export const SET_IS_BHARAT_REG = "SET_IS_BHARAT_REG"
export const SET_IS_NCB = "SET_IS_NCB"

export const RESET_BHARAT_REG_NCB = "RESET_BHARAT_REG_NCB"


// GET STATE
export const GET_STATE_START = "GET_STATE_START"
export const GET_STATE_SUCCESS = "GET_STATE_SUCCESS"
export const GET_STATE_FAILURE = "GET_STATE_FAILURE"
export const GET_STATE_RESET = "GET_STATE_RESET"

// REG
export const GET_REG_START = "GET_REG_START"
export const GET_REG_SUCCESS = "GET_REG_SUCCESS"
export const GET_REG_FAILURE = "GET_REG_FAILURE"
export const GET_REG_RESET = "GET_REG_RESET"

// get-brandNames
// get-modelNames

export const GET_BRAND_START = "GET_BRAND_START"
export const GET_BRAND_SUCCESS = "GET_BRAND_SUCCESS"
export const GET_BRAND_FAILURE = "GET_BRAND_FAILURE"
export const GET_BRAND_RESET = "GET_BRAND_RESET"

export const GET_MODEL_START = "GGET_MODEL_START"
export const GET_MODEL_SUCCESS = "GET_MODEL_SUCCESS"
export const GET_MODEL_FAILURE = "GET_MODEL_FAILURE"
export const GET_MODEL_RESET = "GET_MODEL_RESET"

export const GET_POLICYREPORT_START = "GET_POLICYREPORT_START"
export const GET_POLICYREPORT_SUCCESS = "GET_POLICYREPORT_SUCCESS"
export const GET_POLICYREPORT_FAIL = "GET_POLICYREPORT_FAIL"
export const GET_POLICYREPORT_RESET = "GET_POLICYREPORT_RESET"

export const GET_REFERENCES_START = "GET_REFERENCES_START"
export const GET_REFERENCES_SUCCESS = "GET_REFERENCES_SUCCESS"
export const GET_REFERENCES_FAIL = "GET_REFERENCES_FAIL"
export const GET_REFERENCES_RESET = "GET_REFERENCES_RESET"



export const POLICY_ERROR_RESET = "POLICY_ERROR_RESET"


// Check Policy Number is Duplicate or Not

export const CHECK_POLICY_NUMBER_START = "CHECK_POLICY_NUMBER_START"
export const CHECK_POLICY_NUMBER_SUCCESS = "CHECK_POLICY_NUMBER_SUCCESS"
export const CHECK_POLICY_NUMBER_FAIL = "CHECK_POLICY_NUMBER_FAIL"
export const CHECK_POLICY_NUMBER_RESET = "CHECK_POLICY_NUMBER_RESET"


// Add vehicle make and Model Number to master table
export const ADD_MAKE_MODEL_START = "ADD_MAKE_MODEL_START"
export const ADD_MAKE_MODEL_SUCCESS = "ADD_MAKE_MODEL_SUCCESS"
export const ADD_MAKE_MODEL_FAILURE = "ADD_MAKE_MODEL_FAILURE"
export const ADD_MAKE_MODEL_RESET = "ADD_MAKE_MODEL_RESET"


export const DELETE_POLICY_START = "DELETE_POLICY_START"
export const DELETE_POLICY_SUCCESS = "DELETE_POLICY_SUCCESS"
export const DELETE_POLICY_FAILURE = "DELETE_POLICY_FAILURE"
export const DELETE_POLICY_RESET = "DELETE_POLICY_RESET"


export const REQ_POLICY_REPORT = "REQ_POLICY_REPORT";
export const REQ_POLICY_REPORT_SUCCESS = "REQ_POLICY_REPORT_SUCCESS";
export const REQ_POLICY_REPORT_FAILED = "REQ_POLICY_REPORT_FAILED";

export const POLICY_REPORT_STATUS = "POLICY_REPORT_STATUS";
export const POLICY_REPORT_STATUS_SUCCESS = "POLICY_REPORT_STATUS_SUCCESS";
export const POLICY_REPORT_STATUS_FAILED = "POLICY_REPORT_STATUS_FAILED";

export const DOWNLOAD_POLICY_REPORT = "DOWNLOAD_POLICY_REPORT"
export const DOWNLOAD_POLICY_REPORT_SUCCESS = "DOWNLOAD_POLICY_REPORT_SUCCESS"
export const DOWNLOAD_POLICY_REPORT_FAILED = "DOWNLOAD_POLICY_REPORT_FAILED"

export const RESET_POLICY_REPORT_DOWNLOAD = "RESET_POLICY_REPORT_DOWNLOAD"


export const GET_ALL_POLICY_REPORTS = "GET_ALL_POLICY_REPORTS"
export const GET_ALL_POLICY_REPORTS_SUCCESS = "GET_ALL_POLICY_REPORTS_SUCCESS"
export const GET_ALL_POLICY_REPORTS_FAILED = "GET_ALL_POLICY_REPORTS_FAILED"


export const GET_COMMISSION_PERMISSION = "GET_COMMISSION_PERMISSION"
export const GET_COMMISSION_PERMISSION_SUCCESS = "GET_COMMISSION_PERMISSION_SUCCESS"
export const GET_COMMISSION_PERMISSION_FAILED = "GET_COMMISSION_PERMISSION_FAILED"

// policy files

export const UPLOAD_POLICY_FILE_START = "UPLOAD_POLICY_FILE_START"
export const UPLOAD_POLICY_FILE_SUCCESS = "UPLOAD_POLICY_FILE_SUCCESS"
export const UPLOAD_POLICY_FILE_FAIL = "UPLOAD_POLICY_FILE_FAIL"

export const GET_UPLOADED_POLICY_FILE_START = "GET_UPLOADED_POLICY_FILE_START"
export const GET_UPLOADED_POLICY_FILE_SUCCESS = "GET_UPLOADED_POLICY_FILE_SUCCESS"
export const GET_UPLOADED_POLICY_FILE_FAILURE = "GET_UPLOADED_POLICY_FILE_FAILURE"
export const GET_UPLOADED_POLICY_FILE_RESET = "GET_UPLOADED_POLICY_FILE_RESET"

export const DELETE_POLICY_FILE_START = "DELETE_POLICY_FILE_START"
export const DELETE_POLICY_FILE_SUCCESS = "DELETE_POLICY_FILE_SUCCESS"
export const DELETE_POLICY_FILE_FAILURE = "DELETE_POLICY_FILE_FAILURE"
export const DELETE_POLICY_FILE_RESET = "DELETE_POLICY_FILE_RESET"

export const EDIT_POLICY_FILES = "EDIT_POLICY_FILES"
export const EDIT_POLICY_FILES_SUCCESS = "EDIT_POLICY_FILES_SUCCESS"
export const EDIT_POLICY_FILES_FAILED = "EDIT_POLICY_FILES_FAILED"